<template>
  <div class="course-page-skeleton" aria-hidden="true">
    <div class="course-container">
      <div class="skeleton-back-row">
        <div class="skeleton-button" />
      </div>
      <div class="course-columns">
        <div class="course-main-col">
          <div class="skeleton-block skeleton-title-block" />
          <div class="skeleton-block skeleton-text-block" />
          <div class="skeleton-block skeleton-list-block" />
          <div class="skeleton-block skeleton-curriculum-block" />
          <div class="skeleton-block skeleton-author-block" />
          <div class="skeleton-block skeleton-form-block" />
        </div>
        <div class="course-cover-col">
          <div class="skeleton-cover" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.course-page-skeleton {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 40px;
}

.course-container {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 40px;
  margin-top: 50px;
}

.skeleton-back-row {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}

.skeleton-button {
  width: 180px;
  height: 52px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
}

.course-columns {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -16px;
}

.course-main-col {
  width: 100%;
  padding: 0 16px 32px;
}

.course-cover-col {
  width: 100%;
  padding: 0 16px;
}

.skeleton-block {
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
  margin-bottom: 24px;
}

.skeleton-title-block {
  height: 36px;
  max-width: 70%;
}

.skeleton-text-block {
  height: 80px;
}

.skeleton-list-block {
  height: 120px;
}

.skeleton-curriculum-block {
  height: 200px;
}

.skeleton-author-block {
  height: 140px;
}

.skeleton-form-block {
  height: 320px;
}

.skeleton-cover {
  border-radius: 12px;
  aspect-ratio: 4 / 5;
  max-width: 360px;
  background: linear-gradient(
    90deg,
    var(--color-bg-faq, #eee) 0%,
    #e8e8e8 50%,
    var(--color-bg-faq, #eee) 100%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.2s ease-in-out infinite;
  animation-delay: 0.2s;
}

@media (min-width: 1024px) {
  .course-main-col {
    width: 66.666%;
    padding-right: 100px;
  }

  .course-cover-col {
    width: 33.333%;
  }

  .course-cover-col .skeleton-cover {
    position: sticky;
    top: 24px;
  }
}

@media (max-width: 1400px) {
  .course-container {
    padding: 0 60px;
  }
}

@media (max-width: 991px) {
  .course-container {
    padding: 0 30px;
  }
}

@media (max-width: 767px) {
  .course-page-skeleton,
  .course-container {
    padding: 0 20px;
  }
}

@keyframes skeleton-shimmer {
  to {
    background-position: 200% 0;
  }
}
</style>
